import { ResellerConsumption } from '../../models';
import http, { HttpSuccessOrErrorType, WillStopConfig } from '../http';

export default {

    /**
     * 获取所有集团授权资源 所有集团 包括集团下的餐厅授权
     * @param string_id 餐厅string_id
     */
    async get_reseller_consumption_condition(params: ResellerConsumption, config?: WillStopConfig): Promise<HttpSuccessOrErrorType<{
        dbResults: ResellerConsumption[],
        totalCount: Array<{
            count: number;
        }>
    }[]>> {
        return await http.get(`/consume/records/condition`, {
            params: {
                ...params
            },
            ...config
        })
    },



}